module.exports = __webpack_public_path__ + "img/12345678.46406bc7.png";